import { router } from '@inertiajs/react';
import { toast } from 'sonner';

export default function registerFlashToasts(): () => void {
    const unsubscribe = router.on('flash', (event) => {
        if (event?.detail?.flash?.success) {
            toast.success(String(event.detail.flash.success));
        }

        if (event?.detail?.flash?.error) {
            toast.error(String(event.detail.flash.error));
        }
    });

    return unsubscribe;
}
